// src/Blog/Blog.js
import React from "react";
import { useTheme } from '@mui/material/styles';
import { posts } from './posts';
import BlogCard from './components/BlogCard';
import BlogHeader from './components/BlogHeader';
import './Blog.css';

function Blog() {
  const theme = useTheme();

  return (
    <div
      className="BlogPage"
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        paddingLeft: '15%',
        paddingTop: '100px',
        minHeight: '100vh',
        background: theme.palette.background.default,
        color: theme.palette.text.primary
      }}
    >
      <div style={{ width: '100%', maxWidth: '1000px' }}> {}
        
        <BlogHeader />

        <ul className="Posts" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {posts.map(post => (
            <li key={post.id}>
              <BlogCard post={post} />
            </li>
          ))}
        </ul>

      </div>
    </div>
  );
}

export default Blog;